import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { postsStore } from "../../../../stores/posts/postsStore";
import Typography from "@mui/material/Typography";
import { textColor } from "../../../../assets/styles/colors";
export const PostPageHeader = () => {
    const posts = postsStore.usePosts();
    return (_jsx(_Fragment, { children: posts.length > 0 &&
            _jsx(Typography, { sx: { fontSize: 18, paddingBottom: 1, paddingTop: 1, color: textColor }, color: "text.secondary", gutterBottom: true, children: "Post List" }, void 0) }, void 0));
};
//# sourceMappingURL=PostPageHeader.js.map